import { useState as o } from "react";
const S = ({
  selectedValue: a,
  onSearch: s,
  disableReset: l = !1,
  onChange: n
}) => {
  const [c, e] = o(""), r = (t) => {
    typeof a?.label == "string" ? (n(void 0), e(t)) : typeof a?.label == "object" ? e("") : e(t), s && s(t);
  };
  return {
    searchValue: c,
    handleSearch: r,
    handleResetSearchField: () => {
      r("");
    },
    canResetSearchValue: !!c && !l
  };
};
export {
  S as useSearch
};
